import { render, staticRenderFns } from "./UsersGroup.vue?vue&type=template&id=3499bef8&"
import script from "./UsersGroup.vue?vue&type=script&lang=ts&"
export * from "./UsersGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports